import type { FC } from 'react'
import { useMemo } from 'react'
import CarouselComponent from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'
import cn from 'classnames'
import type { CarouselProps } from '.'
import { Arrows } from './arrows'
import { Dot } from './dot'
import { Thumbnail } from './thumbnail'
import s from './carousel.module.css'

const Carousel: FC<CarouselProps> = ({
  config,
  ssr = false,
  partialVisible = false,
  infinite = false,
  slidesToSlide = 1,
  autoPlay = false,
  showDots = false,
  showArrows = true,
  thumbnails = [],
  className,
  children,
}) => {
  const computedResponsive = useMemo(() => {
    const { wide, desktop, tablet, mobile } = config
    return {
      wide: {
        ...wide,
        breakpoint: { max: 10000, min: 1281 },
      },
      desktop: {
        ...desktop,
        breakpoint: { max: 1280, min: 1024 },
      },
      tablet: {
        ...tablet,
        breakpoint: { max: 1024, min: 464 },
      },
      mobile: {
        ...mobile,
        breakpoint: { max: 464, min: 0 },
      },
    }
  }, [config])

  return (
    <div className={cn(s.root, className)}>
      <CarouselComponent
        swipeable
        infinite={infinite}
        responsive={computedResponsive}
        ssr={ssr}
        minimumTouchDrag={80}
        partialVisible={partialVisible}
        slidesToSlide={slidesToSlide}
        arrows={false}
        autoPlay={autoPlay}
        dotListClass={s.dotsContainer}
        renderButtonGroupOutside={!!(showArrows || showDots)}
        customButtonGroup={<Arrows />}
        customDot={thumbnails.length > 0 ? <Thumbnail thumbnails={thumbnails} /> : <Dot />}
        showDots={showDots}
        className={s.component}
        renderDotsOutside
      >
        {children}
      </CarouselComponent>
    </div>
  )
}

export default Carousel
